var $ = require('jquery');
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import EffectCarousel from './effect-carousel.esm';
const swiper = new Swiper('.swiper', {
    lazy: true,
  // pass EffectCarousel module to modules
  modules: [Autoplay, Navigation, Pagination, EffectCarousel],
  // specify "carousel" effect
  effect: 'carousel',
  grabCursor: true,
  loop: true,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
  autoplay: false,
  on: {
    transitionStart: function(){
      var videos = document.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function(video){
        video.pause();
      });
    },
    
    transitionEnd: function(){
      var activeIndex = this.activeIndex;
      var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
      var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
      activeSlideVideo.play();
      activeSlideVideo.onended = (event) => {
        swiper.slideNext();
      };
    },
  
  }
  
});
$(document).ready(function () {
/* GET ALL VIDEOS */
var sliderVideos = $(".swiper-slide video");
/* SWIPER API - Event will be fired after animation to other slide (next or previous) */
swiper.on('slideChange', function () {
  /* stop all videos  */
  sliderVideos.each(function( index ) {
    this.currentTime = 0;
  });

  /* SWIPER GET CURRENT AND PREV SLIDE (AND The VIDEO INSIDE) */
  var prevVideo =  $(`[data-swiper-slide-index="${this.previousIndex}"]`).find("video");
  //$(`[data-swiper-slide-index="${this.previousIndex}]"`).find("video");
  var currentVideo =  $(`[data-swiper-slide-index="${this.realIndex}"]`).find("video");
    // prevVideo.get(0).pause();
    // // prevVideo.trigger('stop');
    // // currentVideo.trigger('play');
    // currentVideo.get(0).play();
});
// $('video').on("click", function(e){
//  if($(this).hasProp('muted'))  
//  {
//   $(this).removeProp('muted');;
//  }
//  else
//  {
//   $(this).addProp('muted');
//  }

// });




$('video, .swiper-play-img').on("click", function(e){
  if($("video").prop('muted')==true)
  {
    $("video").prop('muted',false);
    $('.swiper-play-img').addClass('swiper-play-img-h');
  }
  else
  {
    $("video").prop('muted',true);
    $('.swiper-play-img').removeClass('swiper-play-img-h');  
  }
  });
});